import { System } from '@ecs/System';
import { Velocity } from '@components/Velocity';
import { Lifetime } from '@components/Lifetime';
import { Renderable } from '@components/Renderable';
import { Tag } from '@components/Tag';
import { ParticleDynamics } from '@components/ParticleDynamics';

const DEFAULT_DRAG = 0.95;

export class ParticleSystem extends System {
  update(_deltaTime: number): void {
    const particles = this.getEntitiesWithComponents(Velocity, Lifetime, Renderable, Tag);

    for (const particle of particles) {
      const tag = particle.getComponent(Tag)!;
      if (tag.value !== 'particle') continue;

      const velocity = particle.getComponent(Velocity)!;
      const lifetime = particle.getComponent(Lifetime)!;
      const renderable = particle.getComponent(Renderable)!;
      const dynamics = particle.getComponent(ParticleDynamics);

      // Slow down particles
      velocity.speed *= dynamics?.drag ?? DEFAULT_DRAG;

      // Rings and smoke expand over time
      if (dynamics?.growth) {
        renderable.size = Math.max(0, renderable.size + dynamics.growth);
      }

      // Fade out based on lifetime
      renderable.alpha = Math.max(0, lifetime.current / lifetime.max);
    }
  }
}
